import { getHeaders, ICreateGraphParams, userStore, withRetry } from "@root/common"
import { TType } from "../types"

type TGetSpreadInfo = { 
  type: string
  coin: string
  long?: string
  short?: string
  exchange: string
  network: string
  timeFrame: number 
}
export async function getSpreadInfo(params: TGetSpreadInfo) {
  const { type: t, long, short, coin, network, timeFrame } = params
  const type = long ? "long" : "short"
  const exchange = long ? long : short
  
  const baseUrl = await userStore.getBaseUrl()
  const response = await withRetry(async () => await fetch(`${baseUrl}/spread-info`, {
      headers: await getHeaders(),
      method: "POST",
      body: JSON.stringify({type, coin, exchange, network, timeFrame}),
  }))
  const json = await response.json()

  return json
}